const decorator = (company) => (item) => (item.hiddenForCompany?.includes(company?.id)
  ? { ...item, hidden: true }
  : { ...item, hidden: false });

const addHiddenStateForItems = (data, company) => (Array.isArray(data)
  ? data.map(decorator(company))
  : { items: data?.items?.map(decorator(company)), total: data?.total });

export default addHiddenStateForItems;
